import { Button, ButtonGroup } from "@mui/material"
import { useState } from "react"

const Switch3 = (props)=> {
    const {defaultValue,items,labels,values,size,sx,onChange,name,disabled} = props
    const [selected,setSelected] = useState(defaultValue||0)
    const handleSelect = (i)=>{
        setSelected(values&&values.length==3?values[i]:i-1)
        onChange && onChange(name,values&&values.length==3?values[i]:i-1)
    }
    return <ButtonGroup  size={size} sx={{...sx,maxHeight:"30px"}} disabled={disabled}>
        <Button disabled={disabled} color="error" title={labels && labels.length == 3 && labels[0]} onClick={()=>handleSelect(0)} variant={selected == (values&&values.length==3?values[0]:-1)?"contained":"outlined"}>{items && items.length==3 ? items[0]:"ON"}</Button>
        <Button disabled={disabled} color="info" title={labels && labels.length == 3 && labels[1]} onClick={()=>handleSelect(1)} variant={selected == (values&&values.length==3?values[1]:0)?"contained":"outlined"}>{items && items.length==3 ? items[1]:"N/A"}</Button>
        <Button disabled={disabled} color="success" title={labels && labels.length == 3 && labels[2]} onClick={()=>handleSelect(2)} variant={selected == (values&&values.length==3?values[2]:1)?"contained":"outlined"}>{items && items.length==3 ? items[2]:"OFF"}</Button>
    </ButtonGroup>
}
export default Switch3